<script setup lang="ts">
import { RouterView } from 'vue-router'
import Loading from 'vue3-loading-overlay'
</script>

<template>
  <suspense>
    <router-view v-slot="{ Component }">
      <suspense timeout="0">
        <template #default>
          <component :is="Component" :key="$route.path" />
        </template>
        <template #fallback>
          <loading
            active
            :can-cancel="false"
            is-full-page
            :height="30"
            :width="30"
            color="#e33349"
            lock-scroll
          />
        </template>
      </suspense>
    </router-view>
  </suspense>
</template>
